import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, timeout: 15000 });

export const endpoints = {
  feed: (params = {}) => api.get("/instagram/feed", { params }).then((r) => r.data),
  profiles: () => api.get("/profiles").then((r) => r.data),
  pillars: () => api.get("/pillars").then((r) => r.data),
  events: (params = {}) => api.get("/events", { params }).then((r) => r.data),
  gallery: (params = {}) => api.get("/gallery", { params }).then((r) => r.data),
  specialties: () => api.get("/enaga/specialties").then((r) => r.data),
  stats: () => api.get("/stats").then((r) => r.data),
  contact: (payload) => api.post("/contact", payload).then((r) => r.data),
  config: () => api.get("/config").then((r) => r.data),
};
